
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";


export default function AuCard(props) {
  const [data, setData] = useState()
  useEffect(() => {
    setData(props.data)
  }, [props.data])

  return (
    <Link className="text-decoration-none" to={`/collection-view/${data?._id}`} state={{data}} >
      <div className="topMeuseumMainBox">
        <div className="imgBox">
          <div className="imginn">
            <img
              className="img-fluid"
              src={data?.bannerImage?.link || "images/newpng/museumphoto.png"}
              alt=""
            />
          </div>
          <div className="meusimphoto">
            <img
              className="img-fluid"
              src={data?.profileImage?.link}
              alt=""
            /></div>
        </div>
        <div className="contBox">
          <div className="arthead justify-content-center mb-2">
            <h2 className="productName">{data?.museumName}</h2>

          </div>
          <p>{data?.description || "---"} </p>
        </div>
        <div className="position-relative">
          <div className="bottomOPtions">
            <ul>
              <li>
                <p>Items</p>
                <h3>--</h3>
              </li>
              <li>
                <p>Views</p>
                <h3>--</h3>
              </li>
              <li>
                <p>Floor Price</p>
                <h3>$ --</h3>
              </li>
              <li>
                <p>7D Volume</p>
                <h3>$ --</h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Link>
  );
}
